import React from "react";
import { FaFilter, FaSearch, FaSyncAlt, FaTimes } from "react-icons/fa";

export default function TeamFiltersCard({
  filters,
  setFilter,
  resetFilters,
  categories,
  filteredCount,
  totalCount,
  loading,
  onRefresh,
}) {
  const hasFilters = filters.query.trim() || filters.categorie;

  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-4 sm:p-5 lg:p-6">
        <div className="mb-4 flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
          <div>
            <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
              Filtres
            </p>

            <h3 className="mt-1 flex items-center gap-2 text-xl font-bold text-slate-900 dark:text-white">
              <FaFilter className="text-indigo-600 dark:text-indigo-300" />
              Recherche des membres
            </h3>

            <p className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-300">
              Recherchez par nom, prénom, fonction, catégorie ou coordonnées.
              Le tableau reste accessible avec défilement horizontal.
            </p>
          </div>

          <div className="flex flex-wrap gap-2">
            {hasFilters ? (
              <button
                type="button"
                onClick={resetFilters}
                className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-bold text-slate-700 shadow-sm transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
              >
                <FaTimes />
                Réinitialiser
              </button>
            ) : null}

            <button
              type="button"
              onClick={onRefresh}
              disabled={loading}
              className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-bold text-slate-700 shadow-sm transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
            >
              <FaSyncAlt className={loading ? "animate-spin" : ""} />
              Actualiser
            </button>
          </div>
        </div>

        <div className="grid gap-3 lg:grid-cols-[1fr,260px]">
          <div className="relative">
            <input
              type="text"
              value={filters.query}
              onChange={(event) => setFilter("query", event.target.value)}
              placeholder="Rechercher nom, prénom, fonction, email..."
              className="w-full rounded-2xl border border-slate-200 bg-white py-2.5 pl-10 pr-3 text-sm font-medium text-slate-700 outline-none transition placeholder:text-slate-400 focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
            />

            <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          </div>

          <select
            value={filters.categorie}
            onChange={(event) => setFilter("categorie", event.target.value)}
            className="w-full rounded-2xl border border-slate-200 bg-white px-3 py-2.5 text-sm font-bold text-slate-700 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
          >
            <option value="">Toutes les catégories</option>
            {categories.map((category) => (
              <option key={category} value={category}>
                {category}
              </option>
            ))}
          </select>
        </div>

        <div className="mt-4 flex flex-wrap gap-2 text-xs text-slate-600 dark:text-slate-300">
          <span className="rounded-full bg-slate-100 px-3 py-1 font-bold dark:bg-slate-800">
            {filteredCount} / {totalCount} membre(s)
          </span>

          {filters.categorie ? (
            <span className="rounded-full bg-indigo-50 px-3 py-1 font-bold text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300">
              Catégorie : {filters.categorie}
            </span>
          ) : null}

          {hasFilters ? (
            <span className="rounded-full bg-indigo-50 px-3 py-1 font-bold text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300">
              Filtres actifs
            </span>
          ) : (
            <span className="rounded-full bg-slate-100 px-3 py-1 font-bold dark:bg-slate-800">
              Aucun filtre
            </span>
          )}
        </div>
      </div>
    </section>
  );
}